<!-- ステータス及び一覧 -->
<template>
  <div>
    <v-card class="main-card" flat>
      <!-- サマリー -->
      <v-card-text>
        <v-item-group v-model="selectedItem" mandatory @change="searchButtonClickEvent">
          <v-row v-if="summaries">
            <!-- 未受付件数 -->
            <v-col :md="!isAllocate ? 3 : null" class="pt-0">
              <v-item v-slot="{ active, toggle }" value="unaccepted">
                <v-card :color="active ? 'error-gradients' : ''" class="rounded-card" @click="toggle">
                  <!-- ヘッダー(MD以上) -->
                  <v-card-text class="text-md-subtitle-1 pb-0 pt-1">
                    <v-row>
                      <v-col cols="12">
                        <span class="font-weight-bold summary" :class="active ? 'white--text' : ''">
                          未受付
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- ヘッダー(SM以下) -->
                  <v-card-text class="pb-1 pt-0">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="fill-width text-center" :class="active ? 'white--text' : ''">
                          <span class="text-h4 font-weight-bold">
                            {{ summaries.unaccepted.count }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="text-right pt-0">
                        <v-icon :color="active ? 'white' : 'primary'">
                          mdi-chevron-down
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /未受付件数 -->

            <!-- 未完了件数 -->
            <v-col :md="!isAllocate ? 3 : null" class="pt-0">
              <v-item v-slot="{ active, toggle }" value="uncompleted">
                <v-card :color="active ? 'error-gradients' : ''" class="rounded-card" @click="toggle">
                  <!-- ヘッダー(MD以上) -->
                  <v-card-text class="text-md-subtitle-1 pb-0 pt-1">
                    <v-row>
                      <v-col cols="12" md="5" sm="5">
                        <span class="font-weight-bold summary" :class="active ? 'white--text' : ''">
                          未完了
                        </span>
                      </v-col>
                      <v-col cols="12" md="7" sm="7" class="text-right">
                        <span class="summary" :class="active ? 'white--text' : ''">
                          {{ yesterday.format('MM/DD') }}まで
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <!-- ヘッダー(SM以下) -->
                  <v-card-text class="pb-1 pt-0">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="fill-width text-center" :class="active ? 'white--text' : ''">
                          <span class="text-h4 font-weight-bold">
                            {{ summaries.uncompleted.count }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="text-right pt-0">
                        <v-icon :color="active ? 'white' : 'primary'">
                          mdi-chevron-down
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /未完了件数 -->

            <!-- 当日の未配車 -->
            <v-col v-if="isAllocate" class="pt-0">
              <v-item v-slot="{ active, toggle }" value="today">
                <v-card :color="active ? 'primary-gradients' : ''" class="rounded-card" @click="toggle">
                  <!-- ヘッダ -->
                  <v-card-text class="text-md-subtitle-1 pb-0 pt-1">
                    <v-row>
                      <v-col cols="12" md="7" sm="6">
                        <span class="font-weight-bold summary" :class="active ? 'white--text' : ''">
                          当日の未配車
                        </span>
                      </v-col>
                      <v-col cols="12" md="5" sm="6" class="text-right">
                        <span class="summary" :class="active ? 'white--text' : ''">
                          {{ today.format('MM/DD') }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text class="pb-1 pt-0">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="fill-width text-center" :class="active ? 'white--text' : ''">
                          <div>
                            <span class="text-h4 font-weight-bold">
                              {{ summaries.today.count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="text-right pt-0">
                        <v-icon :color="active ? 'white' : 'primary'">
                          mdi-chevron-down
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /当日の未配車 -->

            <!-- 翌日の未配車 -->
            <v-col v-if="isAllocate" class="pt-0">
              <v-item v-slot="{ active, toggle }" value="tomorrow">
                <v-card :color="active ? 'primary-gradients' : ''" class="rounded-card" @click="toggle">
                  <v-card-text class="text-md-subtitle-1 pb-0 pt-1">
                    <v-row>
                      <v-col cols="12" md="7" sm="6">
                        <span class="font-weight-bold summary" :class="active ? 'white--text' : ''">
                          翌日の未配車
                        </span>
                      </v-col>
                      <v-col cols="12" md="5" sm="6" class="text-right">
                        <span class="summary" :class="active ? 'white--text' : ''">
                          {{ tomorrow.format('MM/DD') }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text class="pb-1 pt-0">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="fill-width text-center" :class="active ? 'white--text' : ''">
                          <div>
                            <span class="text-h4 font-weight-bold">
                              {{ summaries.tomorrow.count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="text-right pt-0">
                        <v-icon :color="active ? 'white' : 'primary'">
                          mdi-chevron-down
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /翌日の未配車 -->

            <!-- 未配車件数 -->
            <v-col v-if="isAllocate" class="pt-0">
              <v-item v-slot="{ active, toggle }" value="undecided">
                <v-card :color="active ? 'primary-gradients' : ''" class="rounded-card" @click="toggle">
                  <v-card-text class="text-md-subtitle-1 pb-0 pt-1">
                    <v-row>
                      <v-col cols="12" md="6" sm="6">
                        <span class="font-weight-bold summary" :class="active ? 'white--text' : ''">
                          未配車
                        </span>
                      </v-col>
                      <v-col cols="12" md="6" sm="6" class="text-right">
                        <span class="summary" :class="active ? 'white--text' : ''">
                          日付未定
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text class="pb-1 pt-0">
                    <v-row dense>
                      <v-col cols="12">
                        <div class="fill-width text-center" :class="active ? 'white--text' : ''">
                          <div>
                            <span class="text-h4 font-weight-bold">
                              {{ summaries.undecided.count }}
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col class="text-right pt-0">
                        <v-icon :color="active ? 'white' : 'primary'">
                          mdi-chevron-down
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
            <!-- /未配車件数 -->
          </v-row>
        </v-item-group>
      </v-card-text>
      <!-- /サマリー -->

      <v-spacer />

      <!-- 一覧 -->
      <v-card-text>
        <v-row dense>
          <v-col>
            <v-card flat class="rounded-card px-0">
              <v-card-text>
                <v-data-table :headers="tableHeaders" :items="orders" :items-per-page="-1" hide-default-footer
                  disable-sort fixed-header height="29vh">
                  <!-- ステータス -->
                  <template v-slot:[`item.status`]="{ item }">
                    <v-chip x-small label dark :color="item.status | dashboard_status_color(item.type_acceptance, item.order_type)">
                      {{ item.status | dashboard_status_to_label(item.type_acceptance, item.order_type) }}
                    </v-chip>
                  </template>
                  <!-- /ステータス -->
                  <!-- 回収・積替・搬入日 -->

                  <template v-slot:[`item.target_date`]="{ item }">
                    <span v-if="item.target_urgent && !item.target_date">
                      至急
                    </span>
                    <span v-else>
                      <span v-if="item.target_date">
                        <span v-if="item.past_manifest" style="color:#3CBF91">
                          ●
                        </span>
                        {{ item.target_date | date_format }}
                      </span>
                    </span>
                  </template>

                  <!-- /回収・積替・搬入日 -->
                  <!-- 取引先（事業者） -->
                  <template v-slot:[`item.supplier`]="{ item }">
                    <span style="font-size: 90%">{{ item.supplier.name }}</span>
                  </template>
                  <!-- /取引先（事業者） -->
                  <!-- 取引先（事業場） -->
                  <template v-slot:[`item.supplier_location`]="{ item }">
                    <span style="font-size: 90%">{{ item.supplier_location.name }}</span>
                  </template>
                  <!-- /取引先（事業場） -->
                  <!-- 運搬先 -->
                  <template v-slot:[`item.destination_location`]="{ item }">
                    <span style="font-size: 90%">
                      {{ item.destination_location.name }}<small v-if="item.total_traders_count > 0">&emsp;全&nbsp;{{
                        item.total_traders_count }}件</small>
                    </span>
                  </template>
                  <!-- /運搬先 -->
                  <template v-slot:[`item.item`]="{ item }">
                    <div>
                      <v-chip v-if="item.item_name" color="#F0E6D0" drak label x-small :title="item.item_name">
                        {{ item.item_name | truncate(8) }}
                      </v-chip>
                      <span v-else>&emsp;</span>
                    </div>
                    <small>{{ item.packing_name }}</small><small v-if="item.total_items_count > 0">&emsp;全&nbsp;{{
                      item.total_items_count }}件</small>
                  </template>
                  <template v-slot:[`item.editable`]="{ item }">
                    <v-btn :icon="$vuetify.breakpoint.mdAndUp" :bottom="$vuetify.breakpoint.smAndDown"
                      :small="$vuetify.breakpoint.smAndDown"
                      :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2' : null}`"
                      @click="confirmButtonClickEvent(item)">
                      <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                        mdi-file-document-outline
                      </v-icon>
                      <span v-else>
                        確認
                      </span>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <!-- ページャ -->
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pagination.total_pages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="changePage"
            />
          </v-col>
        </v-row>
        <!-- /ページャ -->
      </v-card-text>
      <!-- /一覧 -->
    </v-card>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import PrefectureList from '../../../../mixins/PrefectureList'

export default {
  name: 'DashboardSummary',
  components: {
  },
  mixins: [
    PrefectureList
  ],
  props: {},
  data() {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      selectedItem: 'unaccepted',
      today: this.$dayjs(),
      yesterday: this.$dayjs().subtract(1, 'days'),
      tomorrow: this.$dayjs().add(1, 'days'),
      summaries: {
        unaccepted: {
          type: 'unaccepted',
          count: 0,
        },
        uncompleted: {
          type: 'uncompleted',
          count: 0,
        },
        today: {
          type: 'today',
          count: 0,
        },
        tomorrow: {
          type: 'tomorrow',
          count: 0,
        },
        undecided: {
          type: 'undecided',
          count: 0,
        }
      },
      tableHeaders: [
        { value: 'status', text: 'ステータス', align: 'center' },
        { value: 'target_date', text: '回収・積替・搬入日' },
        { value: 'supplier', text: '取引先（事業者）' },
        { value: 'supplier_location', text: '取引先（事業場）' },
        { value: 'destination_location', text: '運搬先事業場' },
        { value: 'item', text: '品目/荷姿' },
        { value: 'editable', text: '', align: 'end' }
      ],
      orders: [],
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isAllocate: 'use_allocate'
    }),
    ...mapState('DriverDashboardAccepts', {
      pagination: 'pagination',
      searchCondition: "condition",
    }),
  },
  watch: {},
  created() {
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.setCounter()

    this.selectedItem = this.searchCondition.selected_item;
    this.page = this.pagination.current_page
    this.searchManifests()

  },
  methods: {
    ...mapActions('DriverDashboardAccepts', {
      fetchManifests: 'index',
      fetchNumbers: 'show'
    }),
    ...mapActions('DriverManifest', {
      fetchManifest: 'show'
    }),
    searchButtonClickEvent() {
      this.page = 1
      this.searchManifests()
    },
    /**
     * 一覧の取得
     */
    searchManifests() {
      this.orders = []
      switch (this.selectedItem) {
        case 'unaccepted':
          this.searchUnacceptedOrders(this.selectedItem)
          break
        case 'uncompleted':
          this.searchUncompletedOrders(this.selectedItem)
          break
        case 'today':
          this.searchTodayUnassignedOrders(this.selectedItem)
          break
        case 'tomorrow':
          this.searchTomorrowUnassignedOrders(this.selectedItem)
          break
        case 'undecided':
          this.searchUndecidedUnassignedOrders(this.selectedItem)
          break
        default:
      }
    },
    /**
     * ステータス毎の件数を取得する.
     */
    setCounter() {
      this.searchUnacceptedOrderCount()
      this.searchUncompletedOrderCount()
      this.searchTodayUnassignedOrderCount()
      this.searchTomorrowUnassignedOrderCount()
      this.searchUndecidedUnassignedOrderCount()
    },
    /**
     * 未受付件数
     */
    searchUnacceptedOrderCount() {
      this.fetchNumbers({ search_type: 'unaccepted', target_date: null}).then((content) => {
        this.summaries.unaccepted.count = content.number
      })
    },
    /**
     * 未受付一覧
     */
    searchUnacceptedOrders(selected_item) {
      let today = this.today.format('YYYY-MM-DD')
      this.fetchManifests({ search_type: 'unaccepted', target_date: today, page: this.page, selected_item: selected_item}).then((content) => {
        this.orders = content.orders
      })
    },
    /**
     * 未完了件数
     */
    searchUncompletedOrderCount() {
      let today = this.today.format('YYYY-MM-DD')
      this.fetchNumbers({ search_type: 'uncompleted', target_date: today }).then((content) => {
        this.summaries.uncompleted.count = content.number
      })
    },
    /**
     * 未完了一覧
     */
    searchUncompletedOrders(selected_item) {
      // let today = this.today.format('YYYY-MM-DD')
      let today = this.tomorrow.format('YYYY-MM-DD')
      this.fetchManifests({ search_type: 'uncompleted', target_date: today,page: this.page, selected_item: selected_item }).then((content) => {
        this.orders = content.orders
      })
    },
    /**
     * 当日の未配車件数
     */
    searchTodayUnassignedOrderCount() {
      let today = this.today.format('YYYY-MM-DD')
      this.fetchNumbers({ search_type: 'unassigned', target_date: today }).then((content) => {
        this.summaries.today.count = content.number
      })
    },
    /**
     * 当日の未配車一覧
     */
    searchTodayUnassignedOrders(selected_item) {
      let today = this.today.format('YYYY-MM-DD')
      this.fetchManifests({ search_type: 'unassigned', target_date: today,page: this.page, selected_item: selected_item }).then((content) => {
        this.orders = content.orders
      })
    },
    /**
     * 翌日の未配車件数
     */
    searchTomorrowUnassignedOrderCount() {
      let tomorrow = this.tomorrow.format('YYYY-MM-DD')
      this.fetchNumbers({ search_type: 'unassigned', target_date: tomorrow }).then((content) => {
        this.summaries.tomorrow.count = content.number
      })
    },
    /**
     * 翌日の未配車一覧
     */
    searchTomorrowUnassignedOrders(selected_item) {
      let tomorrow = this.tomorrow.format('YYYY-MM-DD')
      this.fetchManifests({ search_type: 'unassigned', target_date: tomorrow,page: this.page, selected_item: selected_item }).then((content) => {
        this.orders = content.orders
      })
    },
    /**
     * 未配車 日付未定件数
     */
    searchUndecidedUnassignedOrderCount() {
      this.fetchNumbers({ search_type: 'unassigned', target_date: null }).then((content) => {
        this.summaries.undecided.count = content.number
      })
    },
    /**
     * 未配車 日付未定一覧
     */
    searchUndecidedUnassignedOrders(selected_item) {
      this.fetchManifests({ search_type: 'unassigned', target_date: null,page: this.page, selected_item: selected_item }).then((content) => {
        this.orders = content.orders
      })
    },
    changePage () {
      this.searchManifests()
    },
    /**
     * 確認ボタン クリックイベント
     * @param item
     * @param item.type_acceptance { Number }
     * @param item.original_id { Number }
     * @param item.order_type {String}
     * @param item.status { String }
     * @param item.has_collection_request { Boolean }
     */
    confirmButtonClickEvent(item) {
      if (item.type_acceptance === 1) {
        // DriverAcceptance
        this.$router.push({ name: 'DriverAcceptance', params: { id: `${item.original_id}` }, query: { d: null } })
      } else if (item.order_type === 'collection') {

        if (['collection_requested', 'collection_accepted'].includes(item.status) && !item.driver) {
          if (item.has_collection_request) {
            /**
             * 産廃回収からの受注登録
             * /driver/orders/accepts/collections/:id/registrations
             */
            this.$router.push({
              name: 'DriverOrderAcceptCollectionRegistrationEdit',
              params: {id: item.original_id},
              query: {d: null}
            })
          } else {
            /**
             * 産廃回収の編集
             * /driver/orders/accepts/collections/:id/edit
             */
            this.$router.push({
              name: 'DriverOrderAcceptCollectionEdit',
              params: {id: item.original_id},
              query: {d: null}
            })
          }
        } else {
          /**
           * 回収詳細
           * /driver/orders/accepts/collections/:id
           */
          this.$router.push({name: 'DriverOrderAcceptCollection', params: {id: item.original_id}, query: {d: null}})
        }
      } else if (item.order_type === 'self_emission') {
        if (['collection_requested', 'collection_accepted'].includes(item.status)) {
          /**
           * 産廃回収の編集
           * /driver/orders/accepts/collections/:id/edit
           */
          this.$router.push({
            name: 'DriverOrderAcceptSelfEmissionEdit',
            params: {id: item.original_id},
            query: {d: null}
          })
        } else {
          /**
           * 回収詳細
           * /driver/orders/accepts/collections/:id
           */
          this.$router.push({name: 'DriverOrderAcceptSelfEmission', params: {id: item.original_id}, query: {d: null}})
        }
      } else if (item.order_type === 'pickup') {
        if (item.status === 'pickup_requested') {
          /**
           * 積替運搬からの受注登録
           * /driver/orders/accepts/pickups/:id/registrations
           */
          this.$router.push({ name: 'DriverOrderAcceptPickupRegistrationEdit', params: { id: item.original_id }, query: { d: null } })
        } else {
          /**
           * 引取詳細
           * /driver/orders/accepts/pickups/:id
           */
          this.$router.push({ name: 'DriverOrderAcceptPickup', params: { id: item.original_id }, query: { d: null } })
        }
      } else if (item.order_type === 'carryin') {

        if (item.login_order_tenant) {
          /**
           * 未受付の場合は受注の画面へ遷移させる
           */
          this.$router.push({ name: 'DriverOrderAcceptCarryInRegistrationEdit', params: { id: item.original_id }, query: { d: null } })
        } else {
          if (item.status === 'carry_in_contacted') {
            /**
             * 搬入予約編集
             * /driver/orders/requests/carry_in/:id/edit
             */
            this.$router.push({ name: 'DriverOrderRequestCarryInEdit', params: { id: item.original_id }, query: { d: null } })
          } else {
            /**
             * 搬入予約詳細
             * /driver/orders/requests/carry_in/:id
             */
            this.$router.push({ name: 'DriverOrderRequestCarryIn', params: { id: item.original_id }, query: { d: null } })
          }
        }
      } else if (item.order_type === 'general') {
        if (['collection_requested', 'collection_accepted'].includes(item.status)) {
          /**
           * 一般廃棄物 編集
           * /driver/orders/accepts/generals/:id/edit
           */
          this.$router.push({ name: 'DriverOrderAcceptGeneralEdit', params: { id: item.original_id }, query: { d: null } })
        } else {
          /**
           * 一般廃棄物 詳細
           * /driver/orders/accepts/generals/:id
           */
          this.$router.push({ name: 'DriverOrderAcceptGeneral', params: { id: item.original_id }, query: { d: null } })
        }
      } else if (item.order_type === 'proxy_request') {
        if (['collection_requested', 'collection_accepted'].includes(item.status)) {
          /**
           * 他社運搬 編集
           * /driver/orders/accepts/proxy_requests/:id/edit
           */
          this.$router.push({ name: 'DriverOrderAcceptProxyRequestEdit', params: { id: item.original_id }, query: { d: null } })
        } else {
          /**
           * 他社運搬 詳細
           * /driver/orders/accepts/proxy_requests/:id
           */
          this.$router.push({ name: 'DriverOrderAcceptProxyRequest', params: { id: item.original_id }, query: { d: null } })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-stepper__step {
  flex-basis: 110px !important;

  &:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) {
    & .v-stepper__step__step {
      background: none !important;
    }
  }
}

.summary {
  font-size: 65%;
}

.v-tooltip__content {
  opacity: 1 !important;
  background-color: #ffffff !important;
  border: 1px solid #dddddd !important;
  color: #565656 !important;
}
</style>
